import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .italic-quote {
    font-style: italic;
    margin-bottom: 20px;
  }

  .highlight {
    color: #02795a;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">Contact</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        To understand my approach to product development, the challenges I've solved, and why I
        believe first-principles thinking + execution velocity trump traditional backgrounds in
        building AI products that matter.
        <a href="/archive">&nbsp;Click to see my story and work ethic.</a>
      </p>

      <p>
        So far so good? Please reach out to me for further discussion around{' '}
        <span className="highlight">
          <b>What</b> you are doing, <b>Why</b> you are doing and <b>How</b> can I help you by
          fitting right in your team.
        </span>
      </p>

      <a className="email-link" href="tel:+91-9636880449">
        Phone Number +91-9636880449
      </a>

      <a className="email-link" href={`mailto:${email}`}>
        E-mail yashrajsrivastava2312@gmail.com
      </a>

      <a className="email-link" href="https://calendly.com/yashrajw16/30min">
        Schedule 1:1 calendly.com/yashrajw16
      </a>
    </StyledContactSection>
  );
};

export default Contact;
